import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import BusComponent from "../../BusComponent";

class FindOpportunitiesItem extends BusComponent {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const { onClick, imgSrc, intl, titleId, subtitleId } = this.props;

        return (
            <div className="find-opportunities__popover__item">
                <button onClick={onClick} className="find-opportunities__popover__item__button">
                    <div className="find-opportunities__popover__item__container">
                        <img
                            src={imgSrc}
                            alt={intl.formatMessage({id: titleId})}
                        />
                        <div className="find-opportunities__popover__item__content">
                    <span className="find-opportunities__popover__item__content__title">
                        {intl.formatMessage({id: titleId})}
                    </span>
                            <span className="find-opportunities__popover__item__content__subtitle">
                        {intl.formatMessage({id: subtitleId})}
                    </span>
                        </div>
                    </div>
                </button>
            </div>
        )
    }
}

FindOpportunitiesItem.propTypes = {
    imgSrc: PropTypes.string.isRequired,
    titleId: PropTypes.string.isRequired,
    subtitleId: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
};

export default injectIntl(FindOpportunitiesItem);
